export default "__VITE_ASSET__Cn9745x$__"